import { useTenantContext } from '@trashlab/sitesapp/src/organizations/redebins/contexts/use-tenant-context';
import { trpcPricingListSkusOpen } from '@trashlab/api/src/generated/hooks';
import { RedebinsDumpsterCard } from '@trashlab/sitesapp/src/organizations/redebins/template/components/dumpster-rentals/dumpster-card';

export const ProductCards = () => {
  const { website } = useTenantContext();
  const tenantId = website?.organization?.id ?? '';

  const { data: skus, isLoading } = trpcPricingListSkusOpen.useQuery(
    {
      tenantId: tenantId ?? '',
      onlineOrderEnabled: true,
      status: 'ACTIVE',
      // Exclude custom price cards (customer-specific or site-specific cards)
      defaultOnly: true,
    },
    {
      enabled: !!tenantId,
    }
  );

  if (isLoading) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-center items-center min-h-[200px]">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#E31837]" />
          </div>
        </div>
      </section>
    );
  }

  if (!skus || skus.length === 0) {
    return null;
  }

  // Sort by cubic yardage (larger first)
  const sortedSkus = [...skus].sort((a, b) => {
    const aYardsRaw = a.product?.cubicYardage;
    const bYardsRaw = b.product?.cubicYardage;

    // Convert to number - handle both string ("5YD") and number formats
    const aYards =
      typeof aYardsRaw === 'string'
        ? parseInt(aYardsRaw.replace(/\D/g, ''), 10) || 0
        : Number(aYardsRaw) || 0;

    const bYards =
      typeof bYardsRaw === 'string'
        ? parseInt(bYardsRaw.replace(/\D/g, ''), 10) || 0
        : Number(bYardsRaw) || 0;

    return bYards - aYards;
  });

  return (
    <section id="dumpster-sizes" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header - matches the dumpster-rentals page */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <em>Choose Your RED-E-BIN</em>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select the perfect dumpster size for your project. Our compact
            dumpsters are designed to fit in your driveway without damaging your
            property.
          </p>
        </div>

        {/* Dumpster Grid - same layout as dumpster-rentals page */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {sortedSkus.map((sku) => (
            <RedebinsDumpsterCard key={sku.id} sku={sku} />
          ))}
        </div>
      </div>
    </section>
  );
};
